import React from 'react';
import { Box, Typography } from '@mui/material';

const AboutSection1 = () => (
    <Box my={3}>
        <Typography variant='subtitle1' textAlign='center' mb={2}>
            KwadHub is for you if:
        </Typography>
        <Typography variant='body1' mb={1}>
            🚁 You're new to UAV flying and looking for safe places to get started.
        </Typography>
        <Typography variant='body1' mb={1}>
            🌄 You’re an experienced pilot seeking fresh spots to explore.
        </Typography>
        <Typography variant='body1'>
            🤝 You want to connect with fellow drone enthusiasts and build a network in your area.
        </Typography>
    </Box>
);

export default AboutSection1;
